<script setup lang="ts">
import { getArticleSpecialApi } from '~/api/article'
import type { Page } from '~/types/base'

const route = useRoute()
// 接口参数
const params = reactive<Page>({
  size: 40,
  current: 1,
})

function handleQuery() {
  const { current = '1' } = route.query as { current: string }

  params.current = +current
}

const { initArticleSpecial } = useInitData()
const { data } = await useAsyncData('articleSpecial', async () => {
  handleQuery()

  const contextInfo = await getArticleSpecialApi(params)
  return contextInfo || initArticleSpecial()
}, {
  watch: [() => route.query],
})

// 客户端也需要同步一次
handleQuery()

const pages = computed(() => data.value?.zonePack.pages || 1)
const games = computed(() => data.value?.zonePack.data || [])

// 顶部header不固定
const { setConf } = useLayout()
setConf({ headerFixed: false })

usePageHeader('blogSpecial')
</script>

<template>
  <div>
    <!-- 顶部导航 -->
    <BlogKitNav :value="data!.types" :type-name="$t('blog_page.blog_special')" />
    <!-- 距离顶部 ui尺寸28px md:45px 需要加上nav高度42px md:65px -->
    <AppBox p="t-12px x-12px b-80px md:t-8px md:x-0">
      <LdCardBox class="pb-40px!">
        <BlogSpecialGameGuide :value="games" />

        <!-- 用插槽的方式处理交互 -->
        <LdPagination v-model:current="params.current" class="mt-40px" :pages="pages" scroll-to-top />
      </LdCardBox>
    </AppBox>
  </div>
</template>

<style lang="scss" scoped>
</style>
